export function distanceKm(lat1, lon1, lat2, lon2) {
  const toRad = (d) => (d * Math.PI) / 180;
  const R = 6371; // earth radius in km
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function formatDistance(km) {
  if (km < 0.5) return "Nearby";
  if (km < 10) return `${km.toFixed(1)} km`;
  return `${Math.round(km)} km`;
}

export function getPosition() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation not supported"));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const p = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        cachePosition(p);
        resolve(p);
      },
      (err) => {
        if (err.code === 1) {
          deviceLocationDenied = true;
          window.dispatchEvent(new Event("roadrnr-device-location"));
        }
        reject(err);
      },
      { enableHighAccuracy: false, timeout: 15000, maximumAge: 60000 }
    );
  });
}

// Persist the last successfully-obtained location so distance labels can render
// immediately on the next load (and survive the async geolocation gap / a new
// preview origin where the permission prompt hasn't been re-granted yet). This
// only ever stores a location the browser already gave us — it never fabricates
// coordinates. Uses the SAME distanceKm/formatDistance pipeline downstream.
let deviceLocationDenied = false;
export function isDeviceLocationDenied() { return deviceLocationDenied; }
const POS_KEY = "roadrnr_last_pos";
export function readCachedPosition() {
  try {
    const v = JSON.parse(localStorage.getItem(POS_KEY));
    if (v && typeof v.lat === "number" && typeof v.lng === "number") return v;
  } catch {
    /* ignore */
  }
  return null;
}
export function cachePosition(pos) {
  deviceLocationDenied = false;
  try {
    if (pos && typeof pos.lat === "number" && typeof pos.lng === "number") {
      localStorage.setItem(POS_KEY, JSON.stringify({ lat: pos.lat, lng: pos.lng, timestamp: Date.now() }));
    }
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new Event("roadrnr-device-location"));
}
